import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import { campaignListForDisabled , campaignListForDisabledReset } from "../../store/actions/campaignActions/campaignListForMarkDisabledActions";
import {
    markActiveInActiveCampaign,
    markActiveInActiveCampaignReset
} from "../../store/actions/campaignActions/markActiveInActiveCampaignActions";
import {useToast} from "../../hooks/useToast";

Modal.setAppElement('#root'); // Set root element to prevent screen readers from reading the modal content.

function CampaignStatus() {
    const dispatch = useDispatch();
    const toast =useToast()
    const campaignListReducer = useSelector(state => state.campaignListForMarkDisabledReducers);
    const markActiveInactiveCampaignReducer = useSelector(state => state.markActiveInActiveCampaignReducers)

    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    // const [userTypeFilter, setUserTypeFilter] = useState('BRAND');
    // const [userStatusFilter, setUserStatusFilter] = useState(false);

    useEffect(() => {
        dispatch(campaignListForDisabled());
    }, []);

    useEffect(() => {
        if (campaignListReducer?.status === 200) {
            console.log("user data", campaignListReducer.data);
            dispatch(campaignListForDisabledReset());
        } else if (campaignListReducer?.status) {
            dispatch(campaignListForDisabledReset());
        }
    }, [campaignListReducer]);

    useEffect(() => {
        if (markActiveInactiveCampaignReducer?.status === 200) {
            console.log("user data", markActiveInactiveCampaignReducer.data);
            toast(markActiveInactiveCampaignReducer.message, "success");
            dispatch(campaignListForDisabled());
            dispatch(markActiveInActiveCampaignReset());
        } else if (markActiveInactiveCampaignReducer?.status) {
            dispatch(markActiveInActiveCampaignReset());
            toast(markActiveInactiveCampaignReducer.message, "error");

        }
    }, [markActiveInactiveCampaignReducer]);

    const openApproveModal = (data) => {
        setSelectedCampaign(data);
        setIsApproveModalOpen(true);
    };

    const openRejectModal = (data) => {
        setSelectedCampaign(data);
        setIsRejectModalOpen(true);
    };

    const closeApproveModal = () => {
        setIsApproveModalOpen(false);
        setSelectedCampaign(null);
    };

    const closeRejectModal = () => {
        setIsRejectModalOpen(false);
        setSelectedCampaign(null);
    };

    const handleApprove = () => {
        if (selectedCampaign) {
            console.log('Approved brand ID:', selectedCampaign);
            dispatch(markActiveInActiveCampaign({
                "campaignId": selectedCampaign.campaignId,
                "enabled": false
            }));
            closeApproveModal();
        }
    };

    const handleReject = () => {
        if (selectedCampaign) {
            console.log('Rejected brand ID:', selectedCampaign);
            dispatch(markActiveInActiveCampaign({
                "campaignId": selectedCampaign.campaignId,
                "enabled": false
            }));
            closeRejectModal();
        }
    };

    // const handleTypeFilterChange = (e) => {
    //     setUserTypeFilter(e.target.value);
    // };
    //
    // const handleStatusFilterChange = (e) => {
    //     setUserStatusFilter(e.target.value == "true" ? true : false);
    // };


    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Platform',
            selector: row => row.platform,
            sortable: true,
        },
        {
            name: 'purpose',
            selector: row => row.purpose,
            sortable: true,
        },
        {
            name: 'Actions',
            width: '200px', // Set a specific width for the "Actions" column
            cell: row => (
                <div className="flex items-center justify-center space-x-2 w-full">
                    {row.isEnabled ? (
                        <button
                            onClick={() => openRejectModal(row)}
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-xl"
                        >
                            InActive
                        </button>
                    ) : (
                        ""
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    return (
        <div className="bg-gradient-to-b from-gray-100 to-gray-300 min-h-screen p-8 font-sans">
            {/* Header */}
            <div className="flex items-center justify-between bg-white rounded-lg p-6 shadow-md mb-6">
                <h1 className="m-0 text-[2.4rem] font-bold text-gray-800">Campaign Status</h1>

            </div>
            {/*<div className="flex space-x-5">*/}

            {/*    <div className="mb-4 text-2xl flex items-center">*/}
            {/*        <label className="mr-4 font-semibold text-gray-700">Filter by type:</label>*/}
            {/*        <select*/}
            {/*            value={userTypeFilter}*/}
            {/*            onChange={handleTypeFilterChange}*/}
            {/*            className="border-2 border-gray-300 bg-gray-100 text-gray-700 rounded-lg px-4 py-2"*/}
            {/*        >*/}
            {/*            <option value="BRAND">BRAND</option>*/}
            {/*            <option value="INFLUENCER">INFLUENCER</option>*/}
            {/*        </select>*/}
            {/*    </div>*/}

            {/*    <div className="mb-4 text-2xl flex items-center">*/}
            {/*        <label className="mr-4 font-semibold text-gray-700">Filter by status:</label>*/}
            {/*        <select*/}
            {/*            value={userStatusFilter}*/}
            {/*            onChange={handleStatusFilterChange}*/}
            {/*            className="border-2 border-gray-300 bg-gray-100 text-gray-700 rounded-lg px-4 py-2"*/}
            {/*        >*/}
            {/*            <option value="true">Active</option>*/}
            {/*            <option value="false">In Active</option>*/}
            {/*        </select>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="bg-white rounded-lg shadow-md p-6">


                {Array.isArray(campaignListReducer?.data) && campaignListReducer.data.length > 0 ? (
                    <DataTable
                        columns={columns}
                        data={campaignListReducer.data}
                        pagination
                        highlightOnHover
                        theme="default"
                        customStyles={{
                            rows: {
                                style: {
                                    fontSize: '16px',
                                    color: '#4a4a4a',
                                    fontWeight: 500,
                                },
                            },
                            headCells: {
                                style: {
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    backgroundColor: '#f1f5f9',
                                    color: '#2c3e50',
                                },
                            },
                        }}
                    />
                ) : (
                    <div className="text-gray-600 text-[2.5rem] text-center mt-8">
                        No records to display.
                    </div>
                )}


            </div>

            {/* Rejection Confirmation Modal */}
            <Modal
                isOpen={isRejectModalOpen}
                onRequestClose={closeRejectModal}
                contentLabel="Confirm Reject"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        width: '500px',
                    },
                }}
            >
                <div className="text-[2rem] mb-5 font-bold">Confirm In Active Campaign</div>
                <p className="text-[2rem] mb-5">Are you sure you want to In Active this Campaign?</p>
                <div className="mt-3 float-right">
                    <button onClick={handleReject}
                            className="bg-red-500 hover:bg-red-700 text-white text-2xl font-bold py-2 px-4 rounded mr-2">
                        Yes
                    </button>
                    <button onClick={closeRejectModal}
                            className="bg-gray-500 hover:bg-gray-700 text-white font-bold text-2xl py-2 px-4 rounded">
                        No
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default CampaignStatus;
